<template>
  <div>
    <div class="header-row">
      <div>
        <h2>短信模板</h2>
        <p>维护登录、修改密码和开始配送短信。阿里云模板请在阿里云控制台审核，通过后填写模板 Code。</p>
      </div>
      <el-button type="primary" plain @click="loadItems">刷新</el-button>
    </div>

    <div class="brand-card table-card">
      <el-table :data="items" stripe>
        <el-table-column prop="scene_name" label="场景" min-width="140" />
        <el-table-column prop="scene_code" label="场景编码" min-width="150" />
        <el-table-column prop="provider" label="服务商" min-width="100" />
        <el-table-column prop="sign_name" label="签名" min-width="120" />
        <el-table-column prop="template_code" label="阿里云模板Code" min-width="160" />
        <el-table-column prop="audit_status" label="状态" min-width="110">
          <template slot-scope="{ row }">{{ statusText(row.audit_status) }}</template>
        </el-table-column>
        <el-table-column prop="content_template" label="模板内容" min-width="280" show-overflow-tooltip />
        <el-table-column label="启用" width="90">
          <template slot-scope="{ row }">{{ row.is_active ? "启用" : "停用" }}</template>
        </el-table-column>
        <el-table-column label="操作" width="240" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="openEdit(row)">编辑</el-button>
            <el-button size="mini" plain @click="submitAudit(row)">确认模板</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="editingItem ? '编辑短信模板' : '短信模板'" :visible.sync="showDialog" width="780px">
      <el-form :model="form" label-width="130px">
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="场景"><el-input v-model="form.scene_name" disabled /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="场景编码"><el-input v-model="form.scene_code" disabled /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="签名"><el-input v-model="form.sign_name" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="阿里云模板Code"><el-input v-model="form.template_code" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="服务商"><el-input v-model="form.provider" disabled /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="状态"><el-input :value="statusText(form.audit_status)" disabled /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="模板内容"><el-input v-model="form.content_template" type="textarea" :rows="4" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="saveTemplate">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchSmsTemplates, submitSmsTemplate, updateSmsTemplate } from "../api/orders";

const emptyForm = () => ({
  scene_code: "",
  scene_name: "",
  provider: "aliyun",
  sign_name: "",
  template_code: "",
  content_template: "",
  tencent_template_id: "",
  audit_status: "approved",
  audit_message: "",
  timeout_minutes: 0,
  is_active: true,
  remark: "",
});

export default {
  data() {
    return {
      items: [],
      showDialog: false,
      editingItem: null,
      form: emptyForm(),
    };
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    statusText(value) {
      if (value === "local") return "未确认";
      if (value === "pending") return "待确认";
      if (value === "approved") return "已确认";
      if (value === "rejected") return "已驳回";
      return "未确认";
    },
    async loadItems() {
      const { data } = await fetchSmsTemplates({ page: 1, page_size: 50 });
      this.items = (data.items || []).map((item) => ({
        ...item,
        template_code: item.template_code || item.tencent_template_id || "",
        provider: item.provider === "tencent" ? "aliyun" : item.provider,
      }));
    },
    openEdit(row) {
      this.editingItem = row;
      this.form = {
        ...emptyForm(),
        ...row,
        provider: "aliyun",
        template_code: row.template_code || row.tencent_template_id || "",
      };
      this.showDialog = true;
    },
    async saveTemplate() {
      await updateSmsTemplate(this.editingItem.id, {
        provider: "aliyun",
        sign_name: this.form.sign_name,
        template_code: this.form.template_code,
        tencent_template_id: this.form.template_code,
        content_template: this.form.content_template,
        remark: this.form.remark,
        is_active: this.form.is_active,
      });
      this.$message.success("已保存");
      this.showDialog = false;
      this.loadItems();
    },
    async submitAudit(row) {
      await submitSmsTemplate(row.id);
      this.$message.success("已确认阿里云模板配置");
      this.loadItems();
    },
  },
};
</script>
